var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.58008752,12.5462412 C6.30243379,12.8183342 5.85313957,12.8183342 5.57800997,12.5437449 L0.206672356,7.18925262 C-0.0709813738,6.912167 -0.068457249,6.46783151 0.211720606,6.19573843 L1.55455501,4.87770957 C1.83220874,4.60312022 2.28150296,4.60561649 2.55915668,4.88020583 L6.09545555,8.40743081 L14.4578811,0.204698132 C14.7355348,-0.0698912153 15.184829,-0.0673949485 15.4624827,0.207194399 L16.7952206,1.5377046 C17.0703503,1.81229395 17.0678261,2.25662944 16.7901724,2.52872252 L6.58008752,12.5462412 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---Register-Clubs---Just-Added---Multiple",
    transform: "translate(-593.000000, -136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toasts/Success",
    transform: "translate(553.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color",
    transform: "translate(40.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#5EA06D",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCheckmark);
export default __webpack_public_path__ + "static/media/notification-checkmark.347c04265af5ad450876a8efd7e376dc.svg";
export { ForwardRef as ReactComponent };